export default __webpack_public_path__ + "static/media/homebannerlogo.64334e0a.svg";